<template>
  <el-form ref="form" :model="form" :rules="rules" label-width="110px">
    <el-form-item label="功能名称" prop="title">
      <el-input v-model.trim="form.name" class="h-40 w-200" :disabled="true"></el-input>
    </el-form-item>
    <el-form-item label="权限标识" prop="rule">
      <el-input v-model.trim="form.rule_name" class="h-40 w-200" :disabled="true"></el-input>
    </el-form-item>
    <el-form-item label="关联表单" prop="model">
      <el-input class="h-40 w-200" v-model="form.model_name" :disabled="true"></el-input>
    </el-form-item>
    <slot name="self-config"></slot>
    <slot name="import-config"></slot>
    <el-form-item label="可用条件" prop="has_condition" v-if="isLimit">
      <el-radio-group v-model="form.has_condition">
        <el-radio :label="0">无限制</el-radio>
        <el-radio :label="1">条件限制</el-radio>
      </el-radio-group>
    </el-form-item>
    <div v-if="showCondition && isLimit">
      <el-form-item label="可用" prop="has_condition">
        <condition-table :condition="form.condition.visible" :inputList="inputList"></condition-table>
      </el-form-item>
      <el-form-item label="不可见" prop="has_condition">
        <condition-table :condition="form.condition.invisible" :inputList="inputList"></condition-table>
      </el-form-item>
      <el-form-item label="禁用" prop="has_condition">
        <condition-table :condition="form.condition.forbiden" :inputList="inputList"></condition-table>
      </el-form-item>
    </div>

    <el-form-item>
      <el-button type="primary" @click="save()" :loading="isLoading">提交</el-button>
      <!-- <el-button type="primary" @click="log">log</el-button> -->
      <el-button @click="goback()">返回</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
  import http from '../../../../assets/js/http'
  import _verify from '../../../../assets/js/verify'
  import modelConfig from '../../../../config/modelConfig'
  import conditionTable from './conditionTable.vue'
  export default {
    props: {
      id: {
        type: Number,
        default() {
          return 0
        }
      },
      form: {
        type: Object,
        default() {
          return {}
        }
      },
      inputList: {
        type: Array,
        default() {
          return []
        }
      },
      isLimit: {
        type: Boolean,
        default() {
          return true
        }
      },
      isDepended: {
        type: Boolean,
        default() {
          return false
        }
      },
      isLogic: {
        type: Boolean,
        default() {
          return false
        }
      }
    },
    data() {
      return {
        rules: {
          'sheet_name': [
            { required: true, message: '请输入工作表名', trigger: 'blur' }
          ],
          'first_import': [
            { required: true, message: '请输入起始导入行数', trigger: 'blur' },
            { validator: this.isNumber, message: '请输入数字', trigger: 'blur' }
          ],
          'limit_size': [
            { required: true, message: '请输入数字', trigger: 'blur' },
            { validator: this.isNumber, message: '请输入数字', trigger: 'blur' }
          ]
          // 'table': [
          //   { validator: this.isIndicators, message: '请输入指标名', trigger: 'blur' }
          // ]
        },
        dependModel: {
          can_select: [],  // 可选字段值
          form_field: '',  // 从属字段
          is_limit: 0,  // 是否限制
          major_field: '',  // 主字段
          major_value: [] // 主字段值
        },
        logicConditionModel: {
          field_name_1: '',
          logic: { id: '=', name: '等于' },
          field_name_2: '',
          logicOptions2: []
        },
        // authTypes: [  // 按钮权限类型
        //   { id: 10, name: '可用' },
        //   { id: 20, name: '禁用' },
        //   { id: 30, name: '不可见' }
        // ],
        // logicTypes: [ // 逻辑数组
        //   { id: '=', name: '等于' },
        //   { id: '!=', name: '不等于' },
        //   { id: '>', name: '大于' },
        //   { id: '<', name: '小于' },
        //   { id: '<=', name: '小于等于' },
        //   { id: '>=', name: '大于等于' },
        //   { id: '70', name: '包含' }
        // ],
        isLoading: false,
        inputListByName: {},
        valueOptions: {},
        logicOptions2: [],
        isInit: false
      }
    },
    methods: {
      // isIndicators(rules, value, callback) {
      //   if (value && value.length > 0) {
      //     let flag = false
      //     _(value).forEach((item) => {
      //       if (!item.name) {
      //         flag = false
      //         return
      //       } else {
      //         flag = true
      //       }
      //     })
      //     if (flag) {
      //       callback()
      //     } else {
      //       callback(new Error('指标名不能为空'))
      //     }
      //   }
      // },
      isNumber(rules, value, callback) {
        if (!_verify.isNumber(value)) {
          callback(new Error('请输入数字'))
        } else {
          callback()
        }
      },
      addDependence() { // 增加从属条件
        this.form.depend_config.push(_.cloneDeep(this.dependModel))
      },
      deleteDependence(index) { // 删除从属关系
        this.form.depend_config.splice(index, 1)
      },
      addLogicCondition() { // 增加逻辑条件
        this.form.logic_condition.push(_.cloneDeep(this.logicConditionModel))
      },
      deleteLogicCondition(index) {
        this.form.logic_condition.splice(index, 1)
      },
      async fieldChange(field_name) {
        let currentField = this.inputListByName[field_name]
        if (currentField && !this.valueOptions.length) {
          switch (currentField.default.type) {
            case this.TYPE_RADIO:
              this.valueOptions[field_name] = currentField.radio_option
              break
            case this.TYPE_CHECKBOX:
              let checkboxOption = _.cloneDeep(currentField.checkbox_option)
              _(checkboxOption).forEach((res) => {
                res.value = res.name
              })
              this.valueOptions[field_name] = checkboxOption
              break
            case this.TYPE_SELECT:
              this.valueOptions[field_name] = currentField.select_option
              break
            case this.TYPE_FOREIGNKEY:
              let keyOption = await this.getKeyOption(currentField.default.field_id)
              _(keyOption).forEach((res) => {
                res.value = res.id
              })
              this.valueOptions[field_name] = keyOption
              break
            default:
              this.valueOptions[field_name] = [{ name: '无限制', value: 0 }]
              break
          }
        } else {
          this.valueOptions[field_name] = [{ name: '无限制', value: 0 }]
        }
      },
      getKeyOption(id) {  // 获取外键数据
        let field = null
        let postData = {}
        _(this.form.field).forEach((res) => {
          if (res.field_id == id) {
            field = res
            return false
          }
        })
        if (field) {
          let majorField = field.key_major
          let depentField = field.key_depent
          if (majorField) {
            postData.major_field = majorField
          }
          if (depentField) {
            postData.depent_field = []
            _(depentField).forEach((res) => {
              postData.depent_field.push(res.name)
            })
          }
        }
        return new Promise((resolve, reject) => {
          this.apiPost(`form/keys/${id}`, postData).then((res) => {
            if (res.code == 200) {
              resolve(res.data.marjorData)
            } else {
              resolve([{ name: '无限制', value: 0 }])
            }
          })
        })
      },
      dependChange() {
        if (!this.form.is_depend) {
          this.form.depend_config = []
        }
      },
      limitTypeChange(item) {
        if (item.is_limit) {
          item.can_select = []
        }
      },
      logicChange() {
        if (!this.form.is_logic) {
          this.form.logic_condition = []
        }
      },
      configLogic(option) {
        if (option.type === this.TYPE_DATE || option.type === this.TYPE_BOTH_DATE_TIME ||
          option.type === this.TYPE_TIME || option.type === this.TYPE_NUMBER) {
          let tempArray = []
          _(this.form.field).forEach((res) => {
            if (res.type === option.type) {
              tempArray.push(res)
            }
          })
          if (tempArray.length >= 2) {
            return true
          }
        }
        return false
      },
      configTypes(option) {
        if (option.id === '70') {
          return false
        }
        return true
      },
      logicFiledChange(optionName,logicIndex) {
        let tempArray = []
        let tempType = null
        _(this.form.field).forEach((res) => {
          if (res.name === optionName) {
            tempType = res.type
          }
        })
        _(this.form.field).forEach((res) => {
          if (res.type === tempType && res.name !== optionName) {
            tempArray.push(res)
          }
        })
        this.form.logic_condition[logicIndex].logicOptions2 = tempArray
        this.form.logic_condition[logicIndex].field_name_2 = ''
      },
      initValueOptions() {
        if (this.form.depend_config) {
          _(this.form.depend_config).forEach((res) => {
            this.fieldChange(res.major_field)
            this.fieldChange(res.form_field)
          })
        }
      },
      sortNumber(a, b) {
        return a - b
      },
      sortGroupLists(config) {
        let curGroupIds = []
        let confirmGroup = []
        if (config.field && config.field.length != 0) {
          config.field.forEach((res) => {
            curGroupIds.push(parseInt(res.group_id))
          })
          curGroupIds = Array.from(new Set(curGroupIds))
          curGroupIds.sort(this.sortNumber)
        }
        curGroupIds.forEach((res) => {
          config.group.forEach((val) => {
            if (val.group_id == res) {
              confirmGroup.push(val)
              return
            }
          })
        })
        return confirmGroup
      },
      log() {
        console.log(this.form)
      },
      save() {
        this.isLoading = true
        let config = _.cloneDeep(this.form)
        delete config.name
        delete config.rule_name
        delete config.model_name
        _(config.logic_condition).forEach((res) => {
          delete res.logicOptions2
        })
        // 整理group数组里的数据，
        config.group = this.sortGroupLists(config)
        // 把控件里的status更新（根据其对应的group_id来配对）
        _(config.field).forEach((res) => {
          _(config.group).forEach((rres) => {
            if (res.group_id == rres.group_id) {
              res.status = rres.status
              return
            }
          })
        })
        if (config.export_config && config.export_config.column) { // 导出操作的一些数据处理
          _(config.export_config.column).forEach((res) => {
            delete res.field_type
            delete res.key_config
            delete res.statistics_configs.foreign_option
            delete res.summaryConfig.foreign_option
            res.statistics_configs.field_option = []
            res.summaryConfig.field_option = []
          })
        }
        let postData = {
          config: config
        }
        if (config.isAll) {
          config.report_type.push(10)
        }
        delete config.isAll
        this.apiPut(`cms/deals/${this.id}`, '', postData).then((res) => {
          if (res.code == 200) {
            _g.toastMsg(this, 'success', '保存成功！')
            setTimeout(() => {
              this.goback()
            }, 1000)
          } else {
            _g.dealError(this, res)
          }
          this.isLoading = false
        })
      },
      goback() {
        // router.go(-1)
        // 判断前面是否存在历史记录路由
        router.replace('/content/list')
      }
    },
    watch: {
      'inputList'() {
        if (this.isDepended) {
          let inputListByName = []
          let valueOptions = {}
          _(this.inputList).forEach((res) => {
            inputListByName[res.default.name] = res
            valueOptions[res.default.name] = []
          })
          this.inputListByName = inputListByName
          this.valueOptions = valueOptions
          if (!this.isInit) {
            this.initValueOptions()
            this.isInit = true
          }
        }
      }
    },
    computed: {
      showCondition() {
        return this.form.has_condition == 1
      }
    },
    components: {
      conditionTable
    },
    mixins: [http, modelConfig]
  }
</script>


// WEBPACK FOOTER //
// commonConfig.vue?4779b38c